export default class App {
  constructor() {
    this.$preloader = $('.preloader-wrap');
  }

  preloader() {
    setTimeout(() => {
      this.$preloader.fadeOut(1000);
    }, 100);
  }

  static disableScrollVideo() {
    if ($('#video-bg-home').length) {
      $('html').addClass('no-scroll');
    }
  }

  init() {
    App.disableScrollVideo();
    this.preloader();
    // this.contactForm();
  }
}

